module.exports = __webpack_public_path__ + "img/lura.a88b1f04.jpg";